(() => {
  if (customElements.get('agdw-contact')) return;

  customElements.define(
    'agdw-contact',
    class extends HTMLElement {
      connectedCallback() {
        this.groupe = this.querySelector('[data-agdw-portes]');
        if (!this.groupe) return;
        this.portes = [...this.groupe.querySelectorAll('[role="radio"]')];
        this.titre = this.querySelector('[data-agdw-titre]');
        this.indication = this.querySelector('[data-agdw-indication]');
        this.message = this.querySelector('[data-agdw-message]');
        this.sujet = this.querySelector('[data-agdw-sujet]');
        this.portes.forEach((porte) => {
          porte.addEventListener('click', () => this.choisir(porte));
        });
        this.groupe.addEventListener('keydown', (e) => this.clavier(e));
        const cle = new URLSearchParams(window.location.search).get('sujet');
        const depart = this.portes.find((p) => cle && p.dataset.cle === cle.toLowerCase());
        if (depart) this.choisir(depart);
      }

      choisir(porte) {
        this.portes.forEach((p) => {
          const actif = p === porte;
          p.setAttribute('aria-checked', actif ? 'true' : 'false');
          p.tabIndex = actif ? 0 : -1;
        });
        const d = porte.dataset;
        if (this.titre) this.titre.textContent = d.libelle;
        if (this.indication) {
          this.indication.textContent = d.indication;
          this.indication.hidden = !d.indication;
        }
        if (this.message) this.message.placeholder = d.exemple;
        if (this.sujet) this.sujet.value = d.sujet;
      }

      clavier(e) {
        const i = this.portes.indexOf(document.activeElement);
        if (i === -1) return;
        let j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % this.portes.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + this.portes.length) % this.portes.length;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = this.portes.length - 1;
        if (j === null) return;
        e.preventDefault();
        this.portes[j].focus();
        this.choisir(this.portes[j]);
      }
    }
  );
})();